import {IImagefrontUrlParts, Imagefront, ImagefrontUrl} from "@syginc/imagefront-client";

export const IMAGE_CONVERT_TYPE_GENERAL_CONTENT_IMAGE = "gci";

export function parseImagefrontUrl(url: string, parts?: Partial<IImagefrontUrlParts>) {
    try {
        return ImagefrontUrl.fromUrl(url, parts);
    } catch {
        return undefined;
    }
}

export function buildImagefrontUrl(
    src: IImagefrontUrlParts,
    parts?: Partial<IImagefrontUrlParts>,
): ImagefrontUrl {
    const merged = parts ? {...src, ...parts} : src;
    return new ImagefrontUrl(merged);
}

export function getImageUrl(
    src: string | IImagefrontUrlParts,
    parts?: Partial<IImagefrontUrlParts>,
): string {
    if (typeof src === "object") {
        return buildImagefrontUrl(src, parts).toString();
    } else {
        return (parseImagefrontUrl(src, parts) || src).toString();
    }
}

function preloadImage(url: string) {
    return new Promise<void>((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            resolve();
        };
        image.onerror = () => {
            reject(new Error("Failed to download an image."));
        };
        image.src = url;
    });
}

export interface UploadImageResultSuccess {
    status: "success";
    url: string;
    fieldId: string;
}

export interface UploadImageResultError {
    status: "error";
    error: Error;
    fieldId: string;
}

export type UploadImageResult = UploadImageResultSuccess | UploadImageResultError;

export async function uploadImage(
    imagefront: Imagefront,
    file: File,
    imageConvertType: string,
    fieldId: string,
): Promise<UploadImageResult> {
    try {
        const url = await imagefront.upload(file);
        const urlTyped = url.copy({ext: "jpg", type: imageConvertType}).toString();
        await preloadImage(urlTyped);
        return {
            status: "success",
            url: urlTyped,
            fieldId: fieldId,
        };
    } catch (e) {
        return {
            status: "error",
            fieldId: fieldId,
            error: e as Error,
        };
    }
}
